import PropTypes from 'prop-types';
import { useTranslations } from 'utils/translations/useTranslations';
import './ProgressBar.scss';

type Props = {
  recipientName: string;
};

export const ProgressBar = ({ recipientName }: Props) => {
  const i18n = useTranslations();
  return (
    <div className="ProgressBar" data-testid="progressBar">
      <div className="ProgressBar-info">
        <span>
          {i18n.t(
            'bankTransfer.instructions.paymentDetailsStep.progressBar.payer.info',
          )}
        </span>
        <span data-testid="recipient-name">{recipientName}</span>
      </div>
      <div className="ProgressBar-group">
        <div className="ProgressBar-dot-start"></div>
        <div className="ProgressBar-fill-1"></div>
        <div className="ProgressBar-fill-2"></div>
        <div className="ProgressBar-dot-end"></div>
      </div>
      <div className="ProgressBar-payment-info">
        {i18n.t(
          'bankTransfer.instructions.paymentDetailsStep.progressBar.payment.info',
        )}
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  recipientName: PropTypes.string,
};
